import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5,0a5,5,0,1,0,5,5A5.006,5.006,0,0,0,5,0ZM4.375,2.5a.625.625,0,0,1,1.25,0v2a.625.625,0,0,1-1.25,0ZM5,8A1,1,0,1,1,6,7,1,1,0,0,1,5,8Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }